const createOnHandler =
  <T>(fn: ((_?: T) => void) | unknown) =>
  (result?: T | unknown) =>
    typeof fn === 'function' ? fn(result) : result;

export default createOnHandler;
